<label>
    <span class="requirement-slider-header">
        <span class="requirement-slider-label sir-text-style-paragraph-m-bold">{{ label() }}</span>
        <output class="requirement-slider-value sir-text-style-title-l-default">
            <span>{{ readout().value }}</span>
            <span class="requirement-slider-unit sir-text-style-paragraph-m-default">{{ readout().unit }}</span>
        </output>
    </span>

    <input
        class="requirement-slider-control"
        type="range"
        [min]="min()"
        [max]="max()"
        [step]="step()"
        [value]="displayValue()"
        [attr.aria-valuetext]="valueText()"
        [style.--robot-selector-slider-fill.%]="fillPercent()"
        (input)="onInput($event)"
        (change)="onChange($event)" />

    <span class="requirement-slider-bounds sir-text-style-system-s-default" aria-hidden="true">
        <span>{{ minText() }}</span>
        <span>{{ maxText() }}</span>
    </span>
</label>
